var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Replace = function Replace(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 717 1024' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M481.311 665.782l153.6 153.6v-36.204l-153.6 153.6c-9.997 9.997-9.997 26.206 0 36.204s26.206 9.997 36.204 0l153.6-153.6c9.997-9.997 9.997-26.206 0-36.204l-153.6-153.6c-9.997-9.997-26.206-9.997-36.204 0s-9.997 26.206 0 36.204z'
      }),
      React.createElement('path', { d: 'M653.012 775.68h-281.6c-155.513 0-281.6-126.087-281.6-281.6 0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6c0 183.79 149.01 332.8 332.8 332.8h281.6c14.138 0 25.6-11.462 25.6-25.6s-11.462-25.6-25.6-25.6zM236.209 370.689L82.609 204.09v34.705l153.6-166.599c9.584-10.395 8.926-26.59-1.469-36.174s-26.59-8.926-36.174 1.469L44.966 204.09c-9.038 9.803-9.038 24.902 0 34.705l153.6 166.599c9.584 10.395 25.779 11.052 36.174 1.469s11.052-25.779 1.469-36.174z'
      }),
      React.createElement('path', { d: 'M63.788 247.043h281.6c155.027 0 281.6 137.285 281.6 307.599 0 14.138 11.462 25.6 25.6 25.6s25.6-11.462 25.6-25.6c0-197.704-148.525-358.799-332.8-358.799h-281.6c-14.138 0-25.6 11.462-25.6 25.6s11.462 25.6 25.6 25.6z'
      })
    )
  );
};
/*eslint-enable */

export default Replace;
//# sourceMappingURL=Replace.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Replace.js